import { all, put, takeLatest } from 'redux-saga/effects';
import { branchSetupActions as actions } from '.';
import { authenticationActions as authActions } from 'features/Authentication/slice/index';

import httpclient from 'libs/Axios/index';
import { PayloadAction } from '@reduxjs/toolkit';
import { BranchSetup } from './types';
import { addPageSize, openWindow } from 'core/utils/constants';
import { YoutubePost } from 'core/utils/types/modules/org';

const MASTER_SERVICE_URLS = ['branchNotification', 'notificationDelivery'];

const getServiceName = (URL: string) => MASTER_SERVICE_URLS.includes(URL) ? 'master' : 'data';

function* fetchBranchSetupList(
  action: PayloadAction<{
    ID: number;
    URL: string;
    ACADEMIC_YEAR_ID?: number;
    holiday_type?: string | undefined;
    column?: string;
    keyword?: number | string;
    ADMISSION_FILTER?: string;
    TABLE_CALL?: boolean;
    TABLE_DATA?: { page_size?: string | number, page_index?: string | number }
    query?: string;
    domainName?: string;
    START_DATE?: string;
    END_DATE?: string;
    moduleAction?: string;
    userActivityModule?: string;
    storeListInDifferentState?: boolean;
  }>,
) {
  const { ID, URL, ACADEMIC_YEAR_ID, holiday_type, column, keyword, ADMISSION_FILTER, TABLE_DATA, query, domainName, START_DATE, END_DATE, moduleAction, userActivityModule, storeListInDifferentState } = action.payload;

  let payload =
    `/${getServiceName(URL)}/` +
    URL +
    '/list/' +
    ID +
    (ACADEMIC_YEAR_ID ? '?academic_year_id=' + ACADEMIC_YEAR_ID : '') +
    (holiday_type ? '&holiday_type=' + holiday_type : '');

  if (URL === "branchPhotoGallery") {
    payload = payload + '&query=NAME=Birthdays';
  } else if (URL === "event") {
    payload = '/comm/' +
      URL +
      '/list/' +
      ID +
      (ACADEMIC_YEAR_ID ? '?academic_year_id=' + ACADEMIC_YEAR_ID + '&page_size=500&page_index=1' : '&page_size=500&page_index=1');
  } else if (URL === "eventDetail") {
    payload = '/comm/eventDetail/list?event_id=' + ID;
  } else if (URL === "academicYear") {
    payload = '/data/' + URL + '/list/' + ID;
  } else if (URL === "studentDocument") {
    payload =
      '/data/' +
      URL +
      '/list/' +
      ID;
  } else if (URL === "branchActivityLog") {
    // payload = '/data/' + URL + '/list/' + ID;
    payload = `/data/${URL}/list/${ID}?start_date=${START_DATE}&end_date=${END_DATE}&query=ACTION=${moduleAction},MODULE_NAME=${userActivityModule}`
  } else if (URL === "masterTemplate") {
    payload = `/master/masterTemplate/list`;
  }

  if (!ACADEMIC_YEAR_ID && !holiday_type) {
    if (URL !== "eventDetail") {
      if (query) {
        payload += `?${query}`
      } else if (Boolean(!!column && !!keyword)) {
        if (URL === "branchPhoto") {
          payload += `?query=BRANCH_PHOTO_ALBUM_ID=${keyword}`
        } else {
          payload += `?query=BRANCH_PHOTO_GALLERY_ID=${keyword}`
        }
      }
    }
  } else if ((!!ACADEMIC_YEAR_ID || !!holiday_type)) {
    if (URL !== "eventDetail") {
      if (query) {
        payload += `&${query}`
      } else if (Boolean(!!column && !!keyword)) {
        if (URL === "branchPhoto") {
          payload += `&query=BRANCH_PHOTO_ALBUM_ID=${keyword}`
        } else {
          payload += `&query=BRANCH_PHOTO_GALLERY_ID=${keyword}`
        }
      }
    }
  } else if (URL === "branchEnquiry") {
    payload = '/data/' + URL + '/list/' + ID + (ACADEMIC_YEAR_ID ? '?academic_year_id=' + ACADEMIC_YEAR_ID : '') + ((!!ADMISSION_FILTER && ADMISSION_FILTER !== "ALL") ? '&query=ENQUIRY_STATUS=' + ADMISSION_FILTER : '')
  }

  try {
    const response = URL !== 'Website' ?
      yield httpclient().get(addPageSize(payload, TABLE_DATA)) :
      yield httpclient().post(`/comm/${URL}/getBranchByDomain`, { DOMAIN_NAME: domainName || 'demo' });
    let data = response?.data?.data;
    let listData
    if (URL === "branchActivityLog") {
      listData = data || {};
    } else if (URL === "branchPhotoGallery") {
      listData = response?.data?.data?.BranchPhotoGalleryList?.map(item => {
        const { ALBUMS_LIST, ...reset } = item;
        return { ...reset, BIRTHDAY_LIST: ALBUMS_LIST, ALBUMS_LIST: [] }
      });
      data = [...listData];
    } else if (URL === 'Website') {
      listData = data?.BranchDetails?.WEBSITE_CONTENT
    } else if (URL === 'parentFeedback') {
      listData = data?.Feedbacks
    } else if (URL === "masterTemplate") {
      data = data?.map((item) => ({
        ...item,
        thumbnail: `https://storage.soomuch.ai/data-soomuch/MASTER/TEMPLATE/${item?.TEMPLATE_NAME}/${item?.TEMPLATE_NAME}_IMAGES/thumbnail.png`,
        url: `https://storage.soomuch.ai/data-soomuch/MASTER/TEMPLATE/${item?.TEMPLATE_NAME}/${item?.TEMPLATE_NAME}_IMAGES/screenshot.png`,
      })) || [];
    } else {
      listData = data[Object.keys(data).at(0)?.toString() as string] || [];
    }
    if (URL === "branchNotification") {
      yield put(authActions?.updateAuthData({ NOTIFICATIONS: listData?.filter(item => !item?.IS_READ) }));
    }
    if (URL === "academicYear") {
      yield put(authActions?.updateAuthData({ ACADEMIC_YEARS: listData }));
    }
    yield put(actions.fetchBranchSetupListSuccess({ listData, data, storeListInDifferentState }));
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.fetchBranchSetupListFailure(errorDetails));
  }
}

function* fetchBranchSetupModalList(
  action: PayloadAction<{
    ID: number;
    URL: string;
    ACADEMIC_YEAR_ID?: number;
    holiday_type?: string | undefined;
    column?: string;
    keyword?: number | string;
    ADMISSION_FILTER?: string;
    TABLE_CALL?: boolean;
    TABLE_DATA?: { page_size?: string | number, page_index?: string | number }
    query?: string;
  }>,
) {
  const { ID, URL, ACADEMIC_YEAR_ID, holiday_type, column, keyword, ADMISSION_FILTER, TABLE_DATA, query } = action.payload;

  let payload =
    `/${getServiceName(URL)}/` +
    URL +
    '/list/' +
    ID +
    (ACADEMIC_YEAR_ID ? '?academic_year_id=' + ACADEMIC_YEAR_ID : '') +
    (holiday_type ? '&holiday_type=' + holiday_type : '');

  if (URL === "branchPhotoGallery") {
    payload = payload + '&query=NAME=Birthdays';
  }

  if (URL === "event") {
    payload = '/comm/' +
      URL +
      '/list/' +
      ID +
      (ACADEMIC_YEAR_ID ? '?academic_year_id=' + ACADEMIC_YEAR_ID + '&page_size=500&page_index=1' : '&page_size=500&page_index=1');
  }

  if (URL === "eventDetail") {
    payload = '/comm/eventDetail/list?event_id=' + ID;
  }

  if (URL === "studentDocument") {
    payload =
      '/data/' +
      URL +
      '/list/' +
      ID;
  } else if (URL === "branchActivityLog") {
    payload = '/data/' + URL + '/list/' + ID;
  }
  if (!ACADEMIC_YEAR_ID && !holiday_type) {
    if (URL !== "eventDetail") {
      if (query) {
        payload += `?${query}`
      } else if (Boolean(!!column && !!keyword)) {
        if (URL === "branchPhoto") {
          payload += `?query=BRANCH_PHOTO_ALBUM_ID=${keyword}`
        } else {
          payload += `?query=BRANCH_PHOTO_GALLERY_ID=${keyword}`
        }
      }
    }
  } else if ((!!ACADEMIC_YEAR_ID || !!holiday_type)) {
    if (URL !== "eventDetail") {
      if (query) {
        payload += `&${query}`
      } else if (Boolean(!!column && !!keyword)) {
        if (URL === "branchPhoto") {
          payload += `&query=BRANCH_PHOTO_ALBUM_ID=${keyword}`
        } else {
          payload += `&query=BRANCH_PHOTO_GALLERY_ID=${keyword}`
        }
      }
    }
  } else if (URL === "branchEnquiry") {
    payload = '/data/' + URL + '/list/' + ID + (ACADEMIC_YEAR_ID ? '?academic_year_id=' + ACADEMIC_YEAR_ID : '') + ((!!ADMISSION_FILTER && ADMISSION_FILTER !== "ALL") ? '&query=ENQUIRY_STATUS=' + ADMISSION_FILTER : '')
  }

  try {
    const response = yield httpclient().get(addPageSize(payload)); // removed TABLE_DATA (argument)
    let data = response?.data?.data;
    let listData
    if (URL === "branchActivityLog") {
      listData = data || {};
    } else if (URL === "branchPhotoGallery") {
      listData = response?.data?.data?.BranchPhotoGalleryList?.map(item => {
        const { ALBUMS_LIST, ...reset } = item;
        return { ...reset, BIRTHDAY_LIST: ALBUMS_LIST, ALBUMS_LIST: [] }
      });
      data = [...listData];
    } else {
      listData = data[Object.keys(data).at(0)?.toString() as string] || [];
    }
    yield put(actions.fetchBranchSetupModalListSuccess({ listData, data }));
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.fetchBranchSetupModalListFailure(errorDetails));
  }
}

function* fetchBranchSetupOne(
  action: PayloadAction<{ ID: number; URL: string, query?: string, ACADEMIC_YEAR_ID?: number }>,
) {
  const { ID, URL } = action.payload;
  try {
    const response = yield httpclient().get(`/${getServiceName(URL)}/${URL}/view?id=${ID}`);
    const data = response?.data?.data;
    yield put(actions.fetchBranchSetupOneSuccess(data));
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.fetchBranchSetupOneFailure(errorDetails));
  }
}
function* fetchBranchSetupOneAttendence(
  action: PayloadAction<{ ID: number; URL: string; ACADEMIC_YEAR_ID: any }>,
) {
  const { ID, URL, ACADEMIC_YEAR_ID } = action.payload;
  try {
    const response = yield httpclient().get(`/data/${URL}/view/${ID}?academic_year_id=${ACADEMIC_YEAR_ID}`);
    const data = response?.data?.data;
    yield put(actions.fetchBranchSetupOneStartAttendenceSuccess(data));
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.fetchBranchSetupOneStartAttendenceFailure(errorDetails));
  }
}

function* createBranchSetup(
  action: PayloadAction<{
    data: BranchSetup | YoutubePost | any;
    URL: string;
    action?: "NOT_CALL" | "NOTIFICATION" | "CALL_VIEW_AND_MAIN_API_AFTER_FORM_SUBMIT" | "CALL_VIEW_API" | string;
    message: string;
    notificationReadAll?: boolean;
  }>,
) {
  const { URL, notificationReadAll } = action.payload;
  let response: any = {};
  try {
    if (Boolean(["facebook/postVideo", "instagram/postVideo", "facebook/postReel", "instagram/postReel"]?.includes(URL))) {
      // EncryptedStorage.removeItem("YOUTUBE_AUTH");
      // EncryptedStorage.removeItem("YOUTUBE_SAVED_DATA");
      response = yield httpclient().post(`/comm/${URL}`, action.payload.data);
      if (!!response?.data?.data?.url) {
        openWindow(response?.data?.data?.url, '_blank');
      }
    } else {
      if (["facebook", "youtube", "instagram", 'googleBusiness']?.includes(URL)) {
        if (Boolean(/* !!action.payload.data?.AUTHORIZATION_CODE &&  */["youtube", "googleBusiness"]?.includes(URL)) || Boolean(["facebook", "instagram"]?.includes(URL))) {
          // EncryptedStorage.removeItem("YOUTUBE_AUTH");
          // EncryptedStorage.removeItem("YOUTUBE_SAVED_DATA");
          response = yield httpclient().post(`/comm/${URL}/post`, action.payload.data);
          if (!!response?.data?.data?.url) {
            openWindow(response?.data?.data?.url, '_blank');
          }
        }/*  else if (Boolean(!action.payload.data?.AUTHORIZATION_CODE && URL === "youtube")) {
          const authResponse = yield httpclient().post(`/comm/${URL === "youtube" ? "google" : URL}/auth`);
          let newwindow: any = openWindow(authResponse?.data?.data?.auth_url, "google auth", 'width=600,height=400');
          if (window.focus as any) { newwindow.focus() }
        } */
      } else {
        response = yield httpclient().post(`/${URL === "eventDetail" ? "comm" : getServiceName(URL)}/${URL}/${URL === "eventDetail" ? "save" : notificationReadAll === true ? "readAll" : "upsert"}`, action.payload.data);
      }
    }
    if (URL === "branchNotification" && notificationReadAll) {
      yield put(authActions?.updateAuthData({ NOTIFICATIONS: [] }));
    }
    if (URL === "academicYear" /* && action.payload.data?.ACADEMIC_YEAR_STATUS === "CURRENT"  */ && !!action.payload.data?.ACADEMIC_YEAR_ID) {
      yield put(authActions.updateAcademicYearListOnUpsert(action.payload.data));
    }
    yield put(actions.createBranchSetupSuccess({
      flag: action.payload.action === "NOT_CALL",
      message: response?.data?.message,
      action: action.payload.action
    }));
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.createBranchSetupFailure(errorDetails));
  }
}

function* deleteBranchSetup(
  action: PayloadAction<{ URL: string; ID: number }>,
) {
  const { URL, ID } = action.payload;
  try {
    const response = yield httpclient().delete(`/${['event', 'eventDetail']?.includes(URL) ? 'comm' : getServiceName(URL)}/${URL}/delete?id=${ID}`);
    const data = response?.data?.data;
    yield put(actions.deleteBranchSetupSuccess());
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.deleteBranchSetupFailure(errorDetails));
  }
}

export function* branchSetupSaga() {
  yield all([
    takeLatest(actions.fetchBranchSetupListStart.type, fetchBranchSetupList),
    takeLatest(actions.fetchBranchSetupModalListStart.type, fetchBranchSetupModalList),
    takeLatest(actions.fetchBranchSetupOneStart.type, fetchBranchSetupOne),
    takeLatest(actions.fetchBranchSetupOneStartAttendence.type, fetchBranchSetupOneAttendence),
    takeLatest(actions.createBranchSetupStart.type, createBranchSetup),
    takeLatest(actions.deleteBranchSetupStart.type, deleteBranchSetup),
  ]);
}
